import { Box, SxProps } from "@mui/material"
import { useStore } from "@priolo/jon"
import { FunctionComponent } from "react"
import parentsSo from "stores/mainMenu/parents"
import natsSo from "stores/nats"
import MenuParents from "./MenuParents"
import MenuSections from "./MenuSections"
import locationSo from "stores/route/location"
import { PAGE_ID } from "stores/route/utils/types"
import ZeroGptMenu from "pages/labs/gpt/Menu"



interface Props {
	sx?: SxProps
}

const MainMenu: FunctionComponent<Props> = ({
	sx,
}) => {

	// STORE
	useStore(locationSo)

	// RENDER
	const currentPageId = locationSo.state.currentPage

	if (currentPageId == PAGE_ID.LABS_GPT) 
		return <ZeroGptMenu />

	return <Box sx={[cssContainer as any, sx]}>
		<MenuParents sx={{ mt: "20px" }} />
		<MenuSections sx={{ mt: "20px" }} />
	</Box>
}

export default MainMenu

const cssContainer: SxProps = {
	display: "flex",
	flexDirection: "column",
}
